import { useFirestoreLoaded } from '../../firebase/useFirestore'
import TargetgroupMeta from '../stakeholders/TargetgroupMeta'
import MultiSelect from '../common/MultiSelect'
import useArrayLinkToggle from '../../hooks/useArrayLinkToggle'

/**
 * Link picker: which target groups this activity reaches. Writes
 * Activities.Targetgroup[] (by stakeholder ID, not docid).
 *
 * @param {object} props
 * @param {{docid: string, Targetgroup?: string[]}} props.activity - The activity whose Targetgroup[] link is edited.
 */
const SelectTargetgroup = ({ activity }) => {
    const [stakeholders, loaded] = useFirestoreLoaded('Stakeholders')
    const toggleLink = useArrayLinkToggle()

    const selected = Array.isArray(activity.Targetgroup) ? activity.Targetgroup : []

    const toggle = (id, isSelected) => toggleLink({
        collection: 'Activities',
        docid: activity.docid,
        field: 'Targetgroup',
        value: id,
        isSelected,
    })

    const options = (stakeholders || []).map(s => ({ id: s.ID, label: s.Organisation }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            loaded={loaded}
            renderSelected={(id) => <TargetgroupMeta targetgroupID={id} />}
            addLabel='+ Doelgroep toevoegen'
            emptyLabel='Geen doelgroep(en) toegevoegd'
            emptyOptionsLabel='Geen doelgroepen beschikbaar'
            removeAriaLabel='Verwijder doelgroep'
        />
    )
}

export default SelectTargetgroup
